module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/zonademand_mobile.22314e61.svg";